module.exports = __webpack_public_path__ + "img/trailerFrame.4cd63bf1.png";